"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventBus = void 0;
var _vue = _interopRequireDefault(require("vue"));
const EventBus = exports.EventBus = new _vue.default();